<div class="h-100 center">
  {{ 'You have no messages' | appTranslate | async }}
</div>
